import { render, staticRenderFns } from "./PendingRegistrationAll.vue?vue&type=template&id=38a62b40&"
import script from "./PendingRegistrationAll.vue?vue&type=script&lang=js&"
export * from "./PendingRegistrationAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports